import { gql } from '@apollo/client';

export const activateBusinessUser = gql`
  mutation activateBusinessUser($entityId: String!) {
    salesforceManagement {
      entities {
        businessUser {
          salesforceManagement {
            activateBusinessUser(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const deactivateBusinessUser = gql`
  mutation deactivateBusinessUser($entityId: String!) {
    salesforceManagement {
      entities {
        businessUser {
          salesforceManagement {
            deactivateBusinessUser(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
